<template>
    <section>
        <div class="container">
			<div class="row mb-2" style="margin-top: 124px;">
                <div class="col">   
                    <h1 class="text-center" style="font-family: 'Cookie', cursive;font-size: 69px;"><i class="far fa-frown"></i></h1>	
					<h1 class="text-center" style="font-family: 'Cookie', cursive;font-size: 69px;">Page Not Found</h1>	
                </div> 
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'PageNotFound',
  data: function(){      
    return {
    }
  },
  mounted: function(){
    
  }
}
</script>